import { BLOCKS, TopLevelBlockEnum } from '@contentful/rich-text-types';
import { IRichText } from '@belong/types';

export const stringToRichText = (value: string, nodeType: TopLevelBlockEnum = BLOCKS.PARAGRAPH): IRichText => ({
  html: {
    nodeType: BLOCKS.DOCUMENT,
    data: {},
    content: [
      {
        nodeType,
        data: {},
        content: [
          {
            value,
            nodeType: 'text',
            marks: [],
            data: {}
          }
        ]
      }
    ]
  }
});
